import React, { Component } from 'react';
import { createRoot } from 'react-dom/client'; // Import createRoot
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './components/home';
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Sales } from './components/Sales';
import AboutPage from './components/about';
import { Layout } from './components/global-components/Layout';
import PropertyDetails from './components/PropertyDetails';
import { Services } from './components/Services';
import { AddJobs } from './components/global-components/AddJobs';
import { Letting } from './components/Letting';
import { WhishlistPage } from './components/WhishlistPage';
import TermsOfUse from './components/TermsOfUse';
import PrivacyPolicy from './components/PrivacyPolicy';
import CookiesPolicy from './components/CookiesPolicy';
import FreeValuationForm from './components/BookEvaluation';
import ScrollToTop from './components/ScrollToTop';
import ProfilePage from './components/ProfilePage';
import { EnquireUs } from './components/enquireus';
import { AllContries } from './components/AllContries';
import { PropertyManagement } from './components/PropertyManagement';
import NewsUpdates from './components/NewsUpdates';
import Blog from './components/Blog';
import ContactPage from './components/contact';
import AmaravatiNews from './components/AmaravatiNews';
import HyderabadNews from './components/HyderabadNews';
import BlogDetail from './components/BlogDetail';
import CommercialPage from './components/CommercialPage';
import ResidentialPage from './components/ResidentialPage';
import AgriculturalPage from './components/AgriculturalPage';
import CustomerReviews from './components/CustomerReviews';
import PropertyNew from './components/section-components/propertynew';
import FeaturedPropertiesPage from './components/FeaturedPropertiesPage';

class Root extends Component {
    render() {
        return (
            <BrowserRouter basename="/">
                <ScrollToTop />
                <div>
                    <Routes>
                        <Route path="/" element={<Layout><Home /></Layout>} />
                        <Route path="/sales/India" element={<Layout><Sales /></Layout>} />
                        <Route path="/services" element={<Layout><Services /></Layout>} />
                        <Route path="/property-management" element={<Layout><PropertyManagement /></Layout>} />
                        <Route path="/property/:id" element={<Layout><PropertyDetails /></Layout>} />
                        <Route path="/valuation" element={<Layout><FreeValuationForm isPage /></Layout>} />
                        <Route path="/about" element={<Layout><AboutPage /></Layout>} />
                        <Route path="/best-properties" element={<Layout><NewsUpdates /></Layout>} />
                        <Route path="/postjob" element={<Layout><AddJobs isPage /></Layout>} />
                        <Route path="/lettings" element={<Layout><Letting /></Layout>} />
                        <Route path="/whishlist" element={<Layout><WhishlistPage /></Layout>} />
                        <Route path="/terms-conditions" element={<Layout><TermsOfUse /></Layout>} />
                        <Route path="/privacy-policy" element={<Layout><PrivacyPolicy /></Layout>} />
                        <Route path="/cookies-policy" element={<Layout><CookiesPolicy /></Layout>} />
                        <Route path="/profile" element={<Layout><ProfilePage /></Layout>} />
                        <Route path="/enquire" element={<Layout><EnquireUs /></Layout>} />
                        <Route path="/allcontries" element={<Layout><AllContries /></Layout>} />
                        <Route path="/blog" element={<Layout><Blog /></Layout>} />
                        <Route path="/blog/:id" element={<Layout><BlogDetail /></Layout>} />
                        <Route path="/blog/:id" element={<Layout><BlogDetail /></Layout>} />
                        <Route path="/blog/amaravathi-news" element={<Layout><AmaravatiNews /></Layout>} />
                        <Route path="/blog/hyderabad-news" element={<Layout><HyderabadNews /></Layout>} />
                        <Route path="/amaravati-news" element={<Layout><AmaravatiNews /></Layout>} />
                        <Route path="/hyderabad-news" element={<Layout><HyderabadNews /></Layout>} />
                        <Route path="/commercial-plots-for-sale-in-amaravati" element={<Layout><CommercialPage /></Layout>} />
                        <Route path="/residential-plots-for-sale-in-amaravati" element={<Layout><ResidentialPage /></Layout>} />
                        <Route path="/agriculture-lands-for-sale-in-amaravati" element={<Layout><AgriculturalPage /></Layout>} />
                        <Route path="/properties" element={<Layout><FeaturedPropertiesPage /></Layout>} />
                        <Route path="/customer-reviews" element={<Layout><CustomerReviews /></Layout>} />
                        <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
                        <Route path="/propertynew" element={<Layout><PropertyNew /></Layout>} />
                    </Routes>
                </div>
            </BrowserRouter>
        );
    }
}

export default Root;

// Find the root element
const container = document.getElementById('royalSpaces');

const root = createRoot(container);
root.render(<Root />);
